import { Button } from 'reactstrap';
import styled from 'styled-components';

export const StyledIframe = styled.iframe``;

export const ChatWidgetWrapper = styled.div`
  right: 90px;
  width: 600px;
  bottom: 140px;
  height: 444px;
  position: fixed;
  z-index: 100000;

  visibility: ${({ isVisible }) => (isVisible ? 'visible' : 'hidden')};

  iframe {
    width: 100%;
    height: 100%;
    background: white;
    position: absolute;
    border-radius: 4px;

    box-shadow: 1px 1px 8px 1px #707171;
  }
`;

export const StylePopOut = styled.div`
  width: 100%;
  height: 50px;
  display: flex;
  margin-bottom: 5px;
  align-items: center;
  justify-content: flex-end;
`;

export const StyledPopOutButton = styled(Button)`
  border: none;
  color: black;
  box-shadow: none;
  border-radius: 0;
  background: white;
  font-weight: bolder;
`;
